import { z } from 'zod';

// WHY (#2119): request body for `POST /requests/:id/duplicate`. The OWNER
// (or admin) duplicates one of their China requests into a NEW DRAFT.
// `clientToken` is the create-idempotency key minted once per duplicate
// action by the web client (#2119 FR-5 single-flight): a dropped-response
// retry of the SAME action resolves to the already-created duplicate
// instead of minting a second row. Canonicalised to lowercase to match the
// `CreateRequestInputSchema` / draft-save clientToken treatment so the
// source-aware idempotent resolve compares the same byte value on every
// retry. The response reuses the existing `RequestSchema` (the new DRAFT's
// wire shape) — no dedicated response schema.

/**
 * @aiPurpose `POST /requests/:id/duplicate` request body (#2119). Carries
 *   only the client-minted idempotency token; the source request id is the
 *   path param and the new owner is server-derived from the actor.
 * @aiInvariant `clientToken` is REQUIRED (unlike the optional draft-save
 *   token) — the duplicate path has no other idempotency key.
 */
export const RequestDuplicateRequestSchema = z
  .object({
    clientToken: z
      .string()
      .uuid('clientToken must be a valid RFC 4122 UUID')
      .transform((s) => s.toLowerCase()),
  })
  .strict();

export type RequestDuplicateRequest = z.infer<typeof RequestDuplicateRequestSchema>;
